/**
 * ============================================================================
 *  File        : frontend/src/components/ui/skeleton.tsx
 *  Module      : components::ui
 *  Purpose     : shadcn/ui skeleton loading placeholder
 *  Author      : EF Engineering
 *  Created     : 2026-05-31
 *  Updated     : 2026-05-31
 *  License     : Proprietary - ECO FAITH Platform v3.0
 * ============================================================================
 */

import type { HTMLAttributes, ReactElement } from 'react'
import { cn } from '../../lib/cn'

export function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): ReactElement {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />
}
